// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"Error404_errorPage__1j1UE"};